<template>
  <div class="page-main">

    <div class="report-dialog">
      <div v-if="!url" class="page-content" id="reportCon">
        <div class="detail-title">{{ detail.title }}</div>
        <div class="detail-user">
<!--          <image mode="aspectFit" class="detail-user-img" :src="detail.authorUrl"/>-->
          <img class="detail-user-img" :src="detail.authorUrl">
          <div class="detail-user-info">
            <div class="detail-user-name">{{ detail.author }}</div>
            <div class="detail-user-date">{{ detail.createdTime }}</div>
          </div>
        </div>
        <div class="detail-content" v-html="detail.content">
        </div>

      </div>
      <div v-else class="img-box">
        <img :src="url"/>
      </div>
      <!-- <div class="btn-footer">
        <div class="btn" @click="saveImg">
          保存到相册并分享
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import VConsole from 'vconsole'

// new VConsole()
import ajax from '../api/ajax';
import {getQueryString} from '../api/restapi';
import {htmlToPDF} from "../utils/html2pdf";
import user_img from '../assets/images/user.png';

export default {
  data() {
    return {
      user_img,
      userName: "",
      recordInfo: {},
      url: '',

      detail: {
        title:"",
        authorUrl:"",
        author:"",
        content:"",
        createdTime:"",
      }
    };
  },
  mounted() {
    console.log("getQueryString('id')",getQueryString('id'))
    this.id = getQueryString('id');
    // this.id = "1877600297181032449";

    document.title =decodeURI(getQueryString('title',true)) ;
    this.getRecordInfo();
  },

  methods: {

    getRecordInfo() {
      ajax
          .Post({
            url: '/api/loss/consult/searchContentById',
            data: {id: this.id}
          }).then(({data: {success, data}}) => {
        if (success) {
          console.log(data)

          // this.recordInfo = {...data}
          this.detail.title = data.title
          this.detail.authorUrl = data.authorUrl
          this.detail.author = data.author
          this.detail.createdTime = data.createdTime
          ajax.Get({
            url: data.content,
            withCredentials: false,
          }).then(r => {
            console.log(r)
            // this.detail.content = r.data
            let content = r.data?.replace(/<img[^>]*>/gi, function (match, ) {
              match = match
                  .replace(/style="[^"]+"/gi, "")
                  .replace(/style='[^']+'/gi, "");
              return match;
            })
                .replace(/<p[^>]*>/gi, function (match, ) {
                  if (match.includes("style")) {
                    match = match
                        .replace(
                            /(style="[^"]+[^;]);?(")/gi,
                            "$1;font-size:16px;line-height:24px;$2"
                        )
                        .replace(
                            /(style='[^']+[^;]);?(')/gi,
                            "$1;font-size:16px;line-height:24px;$2"
                        );
                  } else {
                    match = match.replace(
                        /<p/gi,
                        '<p style="font-size:16px;line-height:24px;"'
                    );
                  }
                  return match;
                })
                .replace(/<span[^>]*>/gi, function (match, ) {
                  if (match.includes("style")) {
                    match = match
                        .replace(
                            /(style="[^"]+[^;]);?(")/gi,
                            "$1;font-size:16px;line-height:24px;$2"
                        )
                        .replace(
                            /(style='[^']+[^;]);?(')/gi,
                            "$1;font-size:16px;line-height:24px;$2"
                        );
                  } else {
                    match = match.replace(
                        /<span/gi,
                        '<span style="font-size:16px;line-height:24px;"'
                    );
                  }
                  return match;
                })
                .replace(
                    /<img/gi,
                    '<img style="display:block;max-width:100%;margin:6px auto;"'
                );

            this.detail.content = content

          })

          // setTimeout(() => {
          //  this.saveImg()
          // }, 200);
        }
      })
    },
    saveImg() {
      htmlToPDF('reportCon', '月报').then(url => {
        this.url = url
      });
    },

  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-main {
}

/* 页面下载内容 */
.report-dialog {
  position: relative;
  min-height: 100vh;
  height: auto;
  /* overflow: auto; */
  padding-bottom: 90px;
  /* background-color: #FBB13D; */
}

.report-dialog {
  width: 100%;
  height: auto;
  /* overflow: auto; */
  /* background-color: #FEDDB5; */
  /* padding-bottom: 40px; */
}

.page-content {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 16px;

}

.page-content .page-title {
  height: 58px;
  line-height: 58px;
  text-align: center;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.page-content .userinfo-box {
  width: 100%;
  height: auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 10px 16px 16px;
  margin-bottom: 14px;
}

.page-content .user-box {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}

.page-content .user-box .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.page-content .user-box .user-name {
  font-size: 18px;
  color: #333333;
}


.detail-title {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin-bottom: 16px;
}

.detail-user {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.detail-user .detail-user-img {
  width: 40px;
  height: 40px;
  display: block;
  margin-right: 8px;
  border-radius: 50%;
}

.detail-user .like-img {
  float: right;
  width: 16px;
  height: 16px;
  display: block;
  margin-top: 12px;
}

.detail-user .detail-user-info {
  flex: 1;
}

.detail-user .detail-user-info .detail-user-name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  margin-bottom: 2px;
}

.detail-user .detail-user-info .detail-user-date {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  /*font-weight: 400;*/
  color: #666666;
  line-height: 14px;
}

.data-table .tr td:first-child {
  width: 52px;
}

.data-table .photo {
  flex: 1;
  width: 104px;
  max-width: 100%;
  /* min-height: 120px; */
  height: auto;
}


.share-card .text {
  flex: 1;
}

.share-card .qrcode {
  width: 48px;
  height: 48px;
}


.img-box {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0
}

.img-box img {
  width: 100%;
  height: auto;
}
.detail-content img {
  max-width: 100%;
}
strong {
  font-weight: bold;
}
</style>
